import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient}from '@angular/common/http';
import { Observable } from 'rxjs';
import { Tsk5020Class } from '../../Class/TSK5020/tsk5020-class';
import { Tsk5011Class } from '../../Class/TSK5011/tsk5011-class';
@Injectable({
  providedIn: 'root'
})
export class Tsk5020Service {

   baseUrl: string=environment.baseUrl + 'tsk5020/';
     constructor(private http:HttpClient) { }
   
 
   GetCommonControlNames(id):Observable<any>
   {
       return this.http.get<any>(this.baseUrl+'GetCommonControlNames/'+id);
   }
 
   LoadControls():Observable<any>
    {
     return this.http.get<any>(this.baseUrl+'LoadControls');
   }
 
   GetControlNames():Observable<any>
   {
     return this.http.get<any>(this.baseUrl+'GetControlNames');
   }
 
   //Load saved data in to find section
  //  LoadFind():Observable<any>
  //  {
  //    return this.http.get<any>(this.baseUrl+'LoadFind');
  //  }

   LoadFind(Tsk5020Class:Tsk5020Class):Observable<any>
    {
      return this.http.post<any>(this.baseUrl+'LoadFind',Tsk5020Class);
    }

    LoadCard(Tsk5020Class:Tsk5020Class):Observable<any>
   {
     return this.http.post<any>(this.baseUrl+'LoadCard',Tsk5020Class);
   }


 
   Create(Tsk5020Class:Tsk5020Class): Observable<any>
   {
     return this.http.post<any>(this.baseUrl+'Create',Tsk5020Class);
   }
 
   DoFind(Tsk5020Class:Tsk5020Class):Observable<any>
   {
     
     return this.http.post<any>(this.baseUrl+'doFind',Tsk5020Class);
   }
 
   //Delete an entry
   Delete(id):Observable<any>
   {
     return this.http.get<any>(this.baseUrl+'Delete/'+id);
   }
 
   LoadEmployeeProjectList(Tsk5020Class:Tsk5020Class):Observable<any>
   {
     return this.http.post<any>(this.baseUrl+'LoadEmployeeProjectList',Tsk5020Class);
   }

   Post(Tsk5020Class:Tsk5020Class):Observable<any>
   {
     return this.http.post<any>(this.baseUrl+'Post',Tsk5020Class);
   }

   GetPostedData(Tsk5020Class:Tsk5020Class):Observable<any>
   {
     return this.http.post<any>(this.baseUrl+'GetPostedData',Tsk5020Class);
   }

    ChangeCompany(id):Observable<any>
{
  return this.http.get<any>(this.baseUrl+'ChangeCompany/'+id);
}


PopUPCreate(Tsk5020Class:Tsk5020Class): Observable<any>
   {
     return this.http.post<any>(this.baseUrl+'PopUPCreate',Tsk5020Class);
   }

   TaskHistory(Tsk5020Class:Tsk5020Class):Observable<any>
   {
     
     return this.http.post<any>(this.baseUrl+'TaskHistory',Tsk5020Class);
   }

  //   Verify(id,TaskId):Observable<any>
  //  {
  //    return this.http.get<any>(this.baseUrl+'Verify/'+id,TaskId);
  //  }

  Verify(id: number, taskId: number): Observable<any> {
  return this.http.get<any>(`${this.baseUrl}Verify/${id}?taskId=${taskId}`);
}

    SaveChecklist(Tsk5020Class:Tsk5020Class): Observable<any>
   {
     return this.http.post<any>(this.baseUrl+'SaveChecklist',Tsk5020Class);
   }


   
   
}
